import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('customer/blacklist', data)

// 获取详情
export const getDetails = id => request().get(`customer/query/${id}`)

// 移出黑名单
export const removedBlacklist = id =>
  request().get(`customer/blacklist/delete/${id}`)
// 删除黑名单
export const deleteRequest = id =>
  request().get(`customer/permanently/delete/${id}`)
//判断是否为管理员角色
export const checkIsAdmin = () => request().get('credit/roleExist')